import React from 'react';
import styled from 'styled-components';

import { Portal } from 'DesignLibrary/atoms';

export const AriaHidden = styled.div`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;
export const AriaHiddenAlert = ({ children }) => (
  <Portal>
    <AriaHidden aria-live="polite">{children}</AriaHidden>
  </Portal>
);
